module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-app/ngfile/ngfile.component.css
// module id = ./src/app/admin-app/ngfile/ngfile.component.css
// module chunks = main